module.exports = __webpack_public_path__ + "img/Monte_Kope_99.0feda48c.jpg";